import api from "./httpClient";
import { API_PATHS } from "./apiPaths";

const extractList = (response) => {
  const payload = response?.data?.data ?? response?.data ?? response ?? [];

  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.content)) return payload.content;
  if (Array.isArray(payload?.items)) return payload.items;
  if (Array.isArray(payload?.rows)) return payload.rows;

  return [];
};

export const getPublicSchools = async () => {
  try {
    const response = await api.get(API_PATHS.public.schools());
    return extractList(response);
  } catch {
    return [];
  }
};

export const getPublicFeedback = async () => {
  try {
    const response = await api.get(API_PATHS.public.feedback());
    return extractList(response);
  } catch {
    return [];
  }
};

export const getPublicLoginAds = async () => {
  try {
    const response = await api.get(API_PATHS.public.loginAds());
    return extractList(response);
  } catch {
    return [];
  }
};

export const trackPublicLoginAdClick = (adId) => {
  if (!adId) return Promise.resolve();
  return api.post(API_PATHS.public.loginAdClick(adId), {}, { withCredentials: false }).catch(() => undefined);
};
